import { render, staticRenderFns } from "./InstantFormLeadMethodSwitch.vue?vue&type=template&id=79ddb9e6&"
import script from "./InstantFormLeadMethodSwitch.vue?vue&type=script&lang=ts&"
export * from "./InstantFormLeadMethodSwitch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports